import { Placement } from '@ng-bootstrap/ng-bootstrap';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Injector, Input, Output, TemplateRef } from '@angular/core';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';

@Component({
  selector: 'app-color-picker-palette',
  templateUrl: './color-picker-palette.component.html',
  styleUrls: ['./color-picker-palette.component.scss'],
  providers: [MakeProvider(ColorPickerPaletteComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ColorPickerPaletteComponent extends AbstractValueAccessor {
  @HostBinding('class.dirty')
  get dirty(): boolean {
    return this.formControl?.dirty;
  }

  @HostBinding('class.invalid')
  get invalid(): boolean {
    return this.formControl?.invalid;
  }

  @HostBinding('class.disabled')
  get disabled(): boolean {
    return this.isDisabled;
  }

  @Input()
  infoTooltip: string | TemplateRef<any>;

  @Input()
  infoTooltipPlacement: Placement;

  @Input()
  infoTooltipClass: string;

  @Input()
  label: string;

  @Input()
  titleWithColon = true;

  @Input()
  labelParamsObj: any;

  @Output()
  colorChanged = new EventEmitter<string>();

  constructor(injector: Injector) {
    super(injector);
  }

  onColorChanged(color: string): void {
    this.colorChanged.emit(color);
  }
}
